<template>
  <div class="slots">
    <h1>Välj en tid för upphämtning</h1>
    <div class="inner">
      <ul v-if="filteredTimeSlots.length">
        <li v-for="slot in filteredTimeSlots" :key="slot.id">
          <button :class="['button', {'is-selected': slot.id === selectedTimeSlot}]" @click.prevent="selectTimeSlot(slot.id)">
            {{ slot.time }}
          </button>
        </li>
      </ul>
      <div v-else>
        <p>
          Det finns tyvärr inga onlinetider kvar idag, men vi kan ha möjlighet att
          ta emot ordrar via telefon. Testa att slå oss en signal på:
        </p>

        <p>
          <a class="phone" href="tel:0840919811">08-409 19 811</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapState('order', ['selectedTimeSlot', 'timeSlots']),
      ...mapGetters('order', ['filteredTimeSlots'])
    },

    methods: {
      selectTimeSlot (slot) {
        this.$store.commit('order/setSelectedTimeSlot', slot);
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'
  @require '~global/breakpoints'

  .slots
    @extend .order-box

  h1
    @extend .t-orderHeader

  ul
    display: grid
    grid-template-columns: repeat(5, 1fr)
    line-height: 0
    grid-gap: .5rem 1rem

  .button
    background: white
    color: $grey-dark
    padding: .6rem 1.2rem
    margin: 0
    border: 1px solid $white
    position: relative
    @extend .t-base
    font-size: 1rem

  .button:hover
    cursor: pointer

  .button:hover, .button.is-selected
    background: $white
    color: $black
    border: 1px solid $black

  p
    text-align: center

  .phone
    color: $red

  @media all and (-ms-high-contrast: none)
    *::-ms-backdrop, ul
      display: flex
      flex-wrap: wrap

    *::-ms-backdrop, li
      margin: .4rem

  @media (max-width: $tablet)
    ul
      grid-template-columns: repeat(4, 1fr)
      grid-gap: .5rem .4rem
    .button
      font-size: 1.1rem

  @media (max-width: 460px)
    ul
      grid-template-columns: repeat(3, 1fr)


  @media (max-width: 360px)
    ul
      grid-template-columns: repeat(2, 1fr)
      grid-gap: .5rem 0rem

</style>
